// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Tu tienda en un móvil',
    desktop: 'Tu tienda en un ordenador',
  },
  loading: 'Cargando la captura de pantalla',
  failed: 'No se pudo cargar la captura de pantalla.',
};
